import React, { useState } from "react";
// import { toast } from "react-hot-toast";
import useFetchProduct from "../../../features/adminDashboard/products/useFetchProduct";
// import useCategory from "../../../features/adminDashboard/category/useCategory";
import Loading from "../../../utils/LoadingIndicator/Loading";
import Dashboard from "../Dashboard";
import { API } from "../../../config";
import CreateProductComponent from "../../../features/adminDashboard/products/CreateProductComponent";
import DeleteProductModal from "../../../features/adminDashboard/products/DeleteProductModal";

const Products = () => {
  const [activeTab, setActiveTab] = useState("view");
  const [editingProduct, setEditingProduct] = useState(null);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    product: null,
  });
  const [filters, setFilters] = useState({
    page: 1,
    limit: 8,
  });
  // const [imagePreview, setImagePreview] = useState("");

  // Use existing hooks
  const {
    products,
    isGettingProducts,
    errGettingProducts,

    // updateProductFn,
    // isUpdatingProduct,
    deleteProductFn,
    isDeletingProduct,
  } = useFetchProduct(filters);

  // const { categories, isGettingCategories } = useCategory();

  const handleEdit = (product) => {
    setEditingProduct(product);
    setActiveTab("create");
  };

  const handleDelete = (product) => {
    setDeleteModal({
      isOpen: true,
      product: product,
    });
  };

  const closeDeleteModal = () => {
    setDeleteModal({
      isOpen: false,
      product: null,
    });
  };

  const confirmDelete = () => {
    if (deleteModal.product) {
      deleteProductFn(deleteModal.product._id);
      closeDeleteModal();
    }
  };

  const handleCancel = () => {
    // resetForm();
    setEditingProduct(null);

    setActiveTab("view");
  };

  // if (isGettingProducts || isGettingCategories) return <Loading />;

  if (errGettingProducts) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <h2 className="text-red-500 text-xl">
          {errGettingProducts || "Failed to load products"}
        </h2>
      </div>
    );
  }

  return (
    <Dashboard
      title="Product Management"
      description="Create and manage products"
    >
      {isGettingProducts ? (
        <Loading />
      ) : (
        <>
          <div className="w-full h-full px-4 pb-8">
            <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
              <button
                onClick={() => setActiveTab("view")}
                className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                  activeTab === "view"
                    ? "bg-white text-gray-900 shadow-sm"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                View Products
              </button>
              <button
                onClick={() => setActiveTab("create")}
                className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                  activeTab === "create"
                    ? "bg-white text-gray-900 shadow-sm"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {editingProduct ? "Edit Product" : "Create Product"}
              </button>
            </div>

            {activeTab === "view" ? (
              <div className="bg-white rounded-lg shadow-lg p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-semibold text-gray-900">
                    All Products ({products?.pagination?.totalItems})
                  </h2>
                  <button
                    onClick={() => setActiveTab("create")}
                    className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
                  >
                    Add New Product
                  </button>
                </div>

                {products?.length === 0 ? (
                  <div className="text-center py-12">
                    <svg
                      className="mx-auto h-12 w-12 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                      />
                    </svg>
                    <h3 className="mt-2 text-sm font-medium text-gray-900">
                      No products
                    </h3>
                    <p className="mt-1 text-sm text-gray-500">
                      Get started by creating a new product.
                    </p>
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Image
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Category
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Price
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Stock
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {products?.data?.map((product) => (
                          <tr key={product._id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap">
                              <img
                                src={`${API}/products/photo/${product._id}`}
                                alt={product?.name}
                                className="w-12 h-12 object-cover rounded-md"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                }}
                              />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm font-medium text-gray-900">
                                {product.name}
                              </div>
                              <div className="text-sm text-gray-500">
                                {product.description?.substring(0, 50)}
                                {product.description?.length > 50 && "..."}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm text-gray-900">
                                {product.category?.name || "No category"}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm font-medium text-gray-900">
                                {product.price} EGP
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm text-gray-900">
                                {product.quantity || product.Quentity || 0}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <div className="flex space-x-2">
                                <button
                                  onClick={() => handleEdit(product)}
                                  className="text-indigo-600 hover:text-indigo-900"
                                >
                                  Edit
                                </button>
                                <button
                                  onClick={() => handleDelete(product)}
                                  className="text-red-600 hover:text-red-900"
                                >
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ) : (
              <CreateProductComponent
                onHandleCancel={handleCancel}
                editingProduct={editingProduct}
              />
            )}
          </div>

          <div className="flex justify-end items-center space-x-4 mt-3">
            <button
              onClick={() =>
                setFilters({
                  ...filters,
                  page:
                    products?.pagination?.currentPagefilter - 1 > 0
                      ? filters.page - 1
                      : 1,
                })
              }
              className="border border-gray-500 py-1 px-2 rounded-md cursor-pointer hover:bg-[#d9d9d983]"
            >
              Prev
            </button>
            <span>
              {products?.pagination?.currentPage} ...from{" "}
              {products?.pagination?.totalPages}
            </span>
            <button
              onClick={() =>
                setFilters({
                  ...filters,
                  page:
                    products?.pagination?.currentPagefilter - 1 <
                    products?.pagination?.totalPages
                      ? filters.page + 1
                      : products?.pagination?.totalPages,
                })
              }
              className="border border-gray-500 py-1 px-2 rounded-md cursor-pointer hover:bg-[#d9d9d983]"
            >
              Next
            </button>
          </div>

          <DeleteProductModal
            isOpen={deleteModal.isOpen}
            onClose={closeDeleteModal}
            onConfirm={confirmDelete}
            productName={deleteModal.product?.name || ""}
            isDeleting={isDeletingProduct}
          />
        </>
      )}
    </Dashboard>
  );
};

export default Products;
